module.exports = __webpack_public_path__ + "static/img/jp_banner.33dc6fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/jp_banner.png
// module id = N7Zv
// module chunks = 6